/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// component
import StepIndicator from 'material/embeds/steps/stepindicator/stepindicator';



/* ========== ~~~~~~~~~~ STEP INDICATOR : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState}) => ({
    stepQueue: embedsState.embedManagementState.embedManagementStatus.stepQueue,
    stepQueueContent: embedsState.embedManagementState.embedManagementStatus.stepQueueContent,
    currentStepPage: embedsState.embedManagementState.embedManagementStatus.currentStepPage,
    isNewEmbedFlow: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.isNewEmbedFlow,
    isSavingData: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.isSavingData,
    changeDetected: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.embedChangeDetected ||
        embedsState.embedManagementState.contentStatus.contentChangeDetected
});

// map actions
// const mapDispatchToProps = dispatch => ({
//
// });



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
	mapStateToProps,
    // mapDispatchToProps
)(StepIndicator);
